import './UserHeader.scss';
import folder from 'assets/images/icons/users/menu/folder.svg';
import chat from 'assets/images/icons/users/menu/ask.svg';
import meeting from 'assets/images/icons/users/menu/appointments.svg';
import askMeeting from 'assets/images/icons/users/menu/appointment-ask.svg';
import cross from 'assets/images/icons/croix.svg';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import logo from 'assets/images/logo-colored.svg';
import { getUser } from 'features/auth/auth.slice';
import useUserHeaderVM from './useUserHeaderVM';

export type UserHeaderItemsType = {
    label: string;
    iconSrc: string;
    url: string;
};

export const userHeaderItems: UserHeaderItemsType[] = [
    { label: 'Mon dossier', iconSrc: folder, url: '/app/user' },
    { label: 'Mes demandes', iconSrc: chat, url: '/app/user/requests' },
    { label: 'Mes rendez-vous', iconSrc: meeting, url: '/app/user/appointments' },
    { label: 'Demander un RDV', iconSrc: askMeeting, url: '/app/user/new-appointment' }
];

export const UserHeader: React.FC = () => {
    const user = useSelector(getUser);
    const location = useLocation();
    const { handleMenuClick } = useUserHeaderVM();

    const isActive = (url: string) => location.pathname === url;

    return (
        <header className="user-header">
            <div className="user-header__brand">
                <img src={logo} className="user-header__logo" alt="DAPV" />
                <span className="user-header__welcome">Espace de {user?.firstname}</span>
            </div>

            <nav className="user-header__nav" aria-label="Navigation principale">
                {userHeaderItems.map((item, index) => (
                    <Link
                        key={index}
                        to={item.url}
                        className={`user-header__nav-item ${isActive(item.url) ? 'user-header__nav-item--active' : ''}`}
                        onClick={() => handleMenuClick(item.label, index)}
                        aria-current={isActive(item.url) ? 'page' : undefined}
                    >
                        <img src={item.iconSrc} alt="" aria-hidden="true" />
                        <span>{item.label}</span>
                    </Link>
                ))}
            </nav>

            <Link
                to="#"
                className="user-header__logout"
                onClick={() => handleMenuClick('Déconnexion', userHeaderItems.length)}
                aria-label="Se déconnecter"
            >
                <img src={cross} alt="" aria-hidden="true" />
                <span>Déconnexion</span>
            </Link>
        </header>
    );
};
